import { create } from "zustand";
import { InputRefState } from "../types";

/**
 * Input ref store for managing input references
 * This store is not persisted as it's temporary state
 */
const useInputRefStore = create<InputRefState>()((set) => ({
  ref: null,
  setRef: (ref) => set({ ref }),
}));

export default useInputRefStore;
